<template>
    <section class="colorlib-about" data-section="about">
        <div class="colorlib-narrow-content">
            <div class="row">
                <div class="col-md-12">
                    <div class="row row-bottom-padded-sm animate-box" data-animate-effect="fadeInLeft">
                        <div class="col-md-12">
                            <div class="about-desc">
                                <span class="heading-meta">About Me</span>
                                <h2 class="colorlib-heading">Who Am I?</h2>
                                <p><strong>Hi I'm Alisher Okhunov</strong> I have been learning Front End development since the 2020 year, I have completed a W3school course in HTML, CSS, and JS. Until this day I participated in several projects and got experience. I have also learned Vue.js, Vuex, VueRouter, and Vuetify, and I did some projects by this framework. I created quick and easy responsive web pages using these.</p>
                                <p>I am passionate about my work. Because I love what I do, I have a constant source of motivation that motivates me to do what I can. This passion led me to test myself every day and learn new skills that will help me do a better job in my last job.</p>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3 animate-box" data-animate-effect="fadeInLeft">
                            <div class="services color-1">
                                <span class="icon2"><i class="icon-bulb"></i></span>
                                <h3>Web developer</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    export default{
        name: "AboutMe"
    }
</script>